import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'school', 'School', [["path",{"d":"M22 9l-10 -4l-10 4l10 4l10 -4v6"}],["path",{"d":"M6 10.6v5.4a6 3 0 0 0 12 0v-5.4"}]]);